<template>
  <div>
    <slice/>
    <div class="container">
        <h2>供应商注册申请</h2>
        <el-form ref="form" :model="form" :rules="rules" label-width="80px">

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="公司名称"  prop="company">
                <el-input v-model="form.company" ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="公司地址" prop="address">
                <el-input v-model="form.address" ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="经办人" prop="jinban">
                <el-input v-model="form.jinban" ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="手机号" prop="phone">
                <el-input v-model="form.phone" ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="邮箱" prop="email">
                <el-input v-model="form.email" ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="开户行" prop="bank_address">
                <el-input v-model="form.bank_address" ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="账号" prop="bank_user">
                  <el-input v-model="form.bank_user" ></el-input>
                </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="税号" prop="tax_user">
                <el-input v-model="form.tax_user" ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="通知方式">(必选)
            <el-checkbox-group 
              v-model="form.message_type"
            >
              <el-checkbox 
                v-for="(item,index) in checkBox" 
                :label="item.value"
                :key="index"
              >
                {{item.label}}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <!-- 很复杂的文件上传部分 -->
          <div class="reg_title">
            请根据自身实际情况下载填写文件
            <a href="http://sys.ahbrt.com/download/offer-app/supplier-reg.doc" target="_blank" class="gys">1.制造商（点我下载）</a>
            <a href="http://sys.ahbrt.com/download/offer-app/supplier-reg2.doc" target="_blank" class="gys">2.经销商（点我下载）</a>
            （必选，二选一）
            <br/>
            1.<b class="font-red">无上方申请表，则审核不通过（ 上传附件中请增加营业执照/生产资质/代理资质/近两年财务简况等文件，各种资质证明越齐全，审核通过率越高 ）。</b><br/>
            2.请使用360/搜狗/谷歌浏览器/Microsoft Edge等浏览器，老IE浏览器不兼容。<br/>
            3.如您上传的为压缩包文件，单个文件请不要超过30M，以防上传失败。<br/>
            4.请阅读博瑞特供应商告知函。<a href="http://sys.ahbrt.com/download/offer-app/supplier-reg2.pdf" class="gys" target="_blank">点击阅读</a><br/>
          </div>

          <el-upload
            list-type="picture-card"
            :action="config.domain"
            :http-request = "supplierUpload"
            :file-list = "fileList"
            :auto-upload="true">
              <i slot="default" class="el-icon-plus"></i>
              <div 
                slot="file"
                slot-scope="{file}">
                <img
                  class="el-upload-list__item-thumbnail"
                  :src="file.url">
                <span class="el-upload-list__item-actions">
                  <span
                      class="el-upload-list__item-delete"
                      @click="handleDownload(file.url)">
                      <i class="el-icon-download"></i>
                  </span>
                  <span
                    v-if="!disabled"
                    class="el-upload-list__item-delete"
                    @click="handleRemove(file)">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
                <span class="file_name">{{file.name}}</span>
              </div>
          </el-upload>
          <br/>

          <el-form-item label="供应类别">(必选)
            <el-tree
              ref="tree"
              :data="tree"
              show-checkbox
              node-key="id"
              :props="defaultProps"
              :default-checked-keys="treeDefaultKeys"
              default-expand-all
              @check-change="checkChange"
            >
            </el-tree>
          </el-form-item>

          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl">
          </el-dialog>

          <div class="font-red" v-if="review.length != 0">
            <el-table
              :data="review"
              stripe
              border
              style="width: 100%">
              <el-table-column
                prop="sh_name"
                label="审核人"
                width="180">
              </el-table-column>
              <el-table-column
                prop="create_time"
                label="审核时间"
                width="180">
              </el-table-column>
              <el-table-column
                prop="_sts"
                label="审核结果"
                width="180">
              </el-table-column>
              <el-table-column
                prop="content"
                label="审核回复" >
              </el-table-column>
            </el-table>
          </div><br/>

          <el-form-item>
            <el-button 
              :type="button" 
              @click="onSubmit('form')" 
              :disabled="sts ? true : false "
            >
            {{buttonTitle}}
            </el-button>
          </el-form-item>
      </el-form>
    </div>
  </div>
</template>


<script>
import * as qiniu from "qiniu-js"
import slice from "@/components/slice"
import {QiniuToken,Reg,Tree,Login,Config} from "@/api/"
export default {
  name:'Reg',
  components:{
    slice
  },
  data(){
    return {
      //登录与登录状态
      code:'',
      button:'primary',
      buttonTitle:'提交审核',
      sts:'',
      

      //树形组件
      tree:[],
      defaultProps: {
          children: 'children',
          label: 'label'
      },
      treeDefaultKeys:[],
      //多选框
      checkBox:[],
      //表单项
      form:{
        message_type:[1,2],
      },
      //账号的审批流
      review:[],
      rules:{
          company: [
            { required: true, message: '请输入公司名称', trigger: 'blur' },
          ],
          address: [
            { required: true, message: '请输入公司地址', trigger: 'blur' },
          ],
          jinban: [
            { required: true, message: '请输入经办人', trigger: 'blur' },
          ],
          phone: [
            { required: true, message: '请输入手机号', trigger: 'blur' },
          ],
          email: [
            { required: true, message: '请输入邮箱', trigger: 'blur' },
            { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
          ],
          bank_address: [
            { required: true, message: '请输入开户行', trigger: 'blur' },
          ],
          bank_user: [
            { required: true, message: '请输入账号', trigger: 'blur' },
          ],
          tax_user: [
            { required: true, message: '请输入税号', trigger: 'blur' },
          ],
      },
      //文件上传组件
      fileList:[],
      config:{
        token:'',
        region:'qiniu.region.z0',  //z0华东区域 z1华北区域  z2代表华南区域  na0北美区域   as0新加坡区域
        domain:'https://upload.qiniup.com',  //上传地址
      },
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false
    }
  },
  mounted(){
    //禁止IE
    if (!!window.ActiveXObject || "ActiveXObject" in window) {
      alert("IE浏览器不兼容，请使用360/搜狗/谷歌浏览器/Microsoft Edge等浏览器进行操作");
    }
    //加载分类
    Tree().then(res=>{
      this.tree = res.data;
    });

    //获取基本信息
    this.code = this.$route.query.code;
    
    if ( this.code ) this.loadDefaultData(this.code);
    this.getQiniuTOken(); //获取token
    this.getConfig(); //获取默认配置文件
  },
  methods:{
    getConfig(){ //获取默认配置
      var that = this;
      Config({configType:'messageType'}).then(res=>{
        that.checkBox = res.data;
      })
    },
    loadDefaultData(code){
      Login({code:code}).then(res=>{
        if ( res.code !== 400 ){
          this.form = res.data.userInfo;
          if (this.form.files) {
            this.fileList = JSON.parse(this.form.files) //文件部分的重载
          }
          this.form.message_type = res.data.userMessage
          this.treeDefaultKeys = res.data.userCate
          this.sts = res.data.userInfo.sts
        } 

        if(res.data.review) {
          this.review = res.data.review
        }

        if ( res.code == 201 ) {
          this.sts = res.data.userInfo.sts
          this.buttonTitle = "审核中";
          this.button = "info";
          this.sts = "0"

        } else if( res.code == 202 ){
          this.sts = res.data.userInfo.sts
          this.buttonTitle = "再次提交审核";
          this.button = "danger";
          this.sts = false

        } else if (res.code == 203 ) {
          this.sts = res.data.userInfo.sts
          this.buttonTitle = "账号被禁用";
          this.button = "danger";
          this.sts = 2

        }

      })
    },
    getQiniuTOken(){ //七牛云的token后端获取,一个token能用一个小时
      QiniuToken().then(res=>{
        if (res.code == 200) {
          this.config.token = res.data.token;
          // this.config.token = "Ud0TbezJXCDFho80dIa_28GVY0gL4OU-0k4DAQot:P3pkfzWJUM7j8_pl57efrsy-cSc=:eyJzY29wZSI6ImJydHN5c3RlbSIsImRlYWRsaW5lIjoxNjU1NzE1MjIzfQ==";
          this.config.url = res.data.url;
        } else {
          this.$mssage.error(res.message);
        }
      })
    },
    //供应商上传方法 https://developer.qiniu.com/kodo/1283/javascript#usage
    supplierUpload(request){
      let token = this.config.token;

      let d = new Date();
      let filePath = d.getFullYear() + '' +d.getMonth();
      let key = 'app-offer/' + filePath + '/' + request.file.uid + request.file.name; //上传的空间地址

      const putExtra = {
        mimeType: null, // mimeType: null || array，用来限制上传文件类型，为 null 时表示不对文件类型限制；限制类型放到数组里： ["image/png", "image/jpeg", "image/gif"]
      };

      let observable = qiniu.upload(request.file,key,token,putExtra);

      var subscription = observable.subscribe(
        (next)=>{
          if (next.total.percent == 100) { //上传成功
            this.$message.success("上传成功");
            this.fileList.push({
              name:request.file.name,
              status:'success',
              uid:request.file.uid,
              url:this.config.url + '/' + key
            })
          }
        }, 
        (error)=>{
          //上传token过期，
          // request.onError(error);
          if (error.code == 401) {
            this.$message.error("页面停滞超过30分钟，请刷新当前页面重新操作。");
          }
        }, 
        (complete)=>{
          console.log(complete)
        }
      ); //上传进度的一些实时反馈信息，搞进度条可以，我这里直接放弃掉
      return subscription;
    },
    handleRemove(file) { //删除文件
      var uid = file.uid;
      var that = this;
      this.fileList.map((item,index)=>{
        if(item.uid == uid) {
          that.fileList.splice(index,1);
        }
      })
    },
    handleDownload(url){ //上传的文件下载
        window.open(url);
    },
    checkChange(data,checked){
      data,checked
      this.form.cate = this.$refs.tree.getCheckedKeys();
    },
    //提交表单
    onSubmit(formName){
      this.$refs[formName].validate((valid) => {
          if (valid) {
            this.form.files = this.fileList;
            Reg({OfferSupplier:this.form}).then(res=>{
              if(res.code == 200) {
                this.$message.success(res.data);
                this.$router.push({name:'Home'})
                
              } else {
                this.$message.error(res.message);
                return false;
              }
            })

          } else {
            return false;

          }
        });
    }
  }
}
</script>

<style lang="less" scoped>
  h2{
    margin-bottom: 15px;
    margin-top: 25px;
    text-align: center;
  }
  .file_name{
    font-size:12px;
  }
  .container{
    width: 1200px;
    margin: 0 auto;
  }
  .reg_title{
    font-size: 14px;
  }
  .font-red{
    color: red;
  }
  .gys{
    text-decoration: none;
    margin-right: 20px;
  }
  .el-upload-list__item-thumbnail{
    max-height: 146px;
  }
</style>